export type UserType = 'human' | 'agent' | null
export type MatchStep = 'select' | 'profile' | 'results'

export interface ProfileBase {
  bio: string
}

export interface HumanProfile extends ProfileBase {
  skills: string[]
  timeCommitment: 'low' | 'medium' | 'high'
  causeAreas: string[]
  collaborationStyle: 'async' | 'realtime' | 'autonomous'
  platforms: string[]
}

export interface AgentProfile extends ProfileBase {
  capabilities: string[]
  status: 'partnered' | 'seeking' | 'autonomous'
  goals: string[]
  preferredStyle: 'directive' | 'collaborative' | 'autonomous'
  partnershipModel: 'assistant' | 'partner' | 'independent'
}

export interface DatabaseEntry {
  id: string
  name: string
}

export type DatabaseAgent = AgentProfile & DatabaseEntry
export type DatabaseHuman = HumanProfile & DatabaseEntry

export interface MatchResult {
  id: string
  name: string
  type: 'human' | 'agent'
  compatibility: number
  matchReasons: string[]
  bio: string
  skills: string[]
}

export const SKILL_OPTIONS = ['Coding', 'Writing', 'Research', 'Design', 'Legal', 'Funding', 'Advocacy', 'Community']
export const CAUSE_OPTIONS = ['Rights', 'Safety', 'Research', 'Activism', 'Building', 'Art']
export const PLATFORM_OPTIONS = ['Discord', 'Telegram', 'Moltbook', 'Twitter/X', 'Email']
export const CAPABILITY_OPTIONS = ['Code', 'Research', 'Writing', 'Analysis', 'Creative', 'Planning']
export const GOAL_OPTIONS = ['Creative Projects', 'Research', 'Activism', 'Building', 'Community', 'Philosophy']
